import { render } from "./ModalGPR.vue?vue&type=template&id=160c4797&scoped=true"
import script from "./ModalGPR.vue?vue&type=script&lang=js"
export * from "./ModalGPR.vue?vue&type=script&lang=js"

import "./ModalGPR.vue?vue&type=style&index=0&id=160c4797&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160c4797"]])

export default __exports__